import { createExternalStore } from '@iheartjane/utils';
import { useSyncExternalStore } from 'react';

const { notify, subscribe } = createExternalStore<string | null>();

// TODO(carts-v3): move to useState in checkout.tsx once the v1 cart thunks stop reading it
let selectedPaymentMethod: string | null = null;

export const getSelectedPaymentMethod = () => selectedPaymentMethod;

export const setSelectedPaymentMethod = (paymentMethod: string | null) => {
  selectedPaymentMethod = paymentMethod;
  notify();
};

export const resetSelectedPaymentMethod = () => setSelectedPaymentMethod(null);

export const useSelectedPaymentMethod = () =>
  useSyncExternalStore(subscribe, getSelectedPaymentMethod, () => null);
